import React from 'react'
import ME from '../../assets/me.jpeg'
import {FaAward} from 'react-icons/fa'
import {FiUser} from 'react-icons/fi'
import {AiTwotoneFolderOpen} from 'react-icons/ai'
import './about.css'

function About() {
  return (
    <section id='about'>
      <h5>Get to know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img src={ME} alt='about'/>
          </div>
        </div>
          <div className='about__content'>
            <div className='about__cards'>
              <article className='about__card'>
                <FaAward className='about__icon'/>
                <h5>Experience</h5>
                <small>2+ years</small>
              </article>

              <article className='about__card'>
                <FiUser className='about__icon'/>
                <h5>Clients</h5>
                <small>200+ people</small>
              </article>

              <article className='about__card'>
                <AiTwotoneFolderOpen className='about__icon'/>
                <h5>Projects</h5>
                <small>10+ projects</small>
              </article>
            </div>
              <p>
                Laborum aliquip veniam do consectetur duis officia amet enim elit labore aliquip. Ad aliqua mollit Lorem aliqua nisi fugiat reprehenderit. Ea commodo reprehenderit exercitation cillum amet nostrud.
              </p>

              <a className='btn btn-primary' href='#contact'>
                Let's Talk
              </a>
        </div>
      </div>
    </section>
  )
}

export default About